import {
  type JSX,
  type ReactNode,
  createContext,
  useContext,
  useState,
} from "react";

import { useCsConfiguration } from "@plansoft-configuration-renderer/framework";

interface ConfigurationTreeContextValue {
  pinned: boolean;
  setPinned: (pinned: boolean) => void;
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

const ConfigurationTreeContext = createContext<
  ConfigurationTreeContextValue | undefined
>(undefined);

interface ConfigurationTreeProviderProps {
  children: ReactNode;
}

export function ConfigurationTreeProvider({
  children,
}: ConfigurationTreeProviderProps): JSX.Element {
  const { properties } = useCsConfiguration();
  const [pinned, setPinned] = useState(
    properties?.pinTreeControl?.value ?? false,
  );
  const [expanded, setExpanded] = useState(
    !(properties?.collapseTreeControl?.value ?? false),
  );

  const value: ConfigurationTreeContextValue = {
    pinned,
    setPinned,
    expanded,
    setExpanded,
  };

  return (
    <ConfigurationTreeContext.Provider value={value}>
      {children}
    </ConfigurationTreeContext.Provider>
  );
}

export function useConfigurationTreeContext(): ConfigurationTreeContextValue {
  const context = useContext(ConfigurationTreeContext);

  if (context === undefined) {
    throw new Error(
      "useConfigurationTreeContext must be used within a ConfigurationTreeProvider",
    );
  }

  return context;
}
